import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import CursorContext from '../../providers/Cursor';

/**
 * Casilla de aceptación de la política, para los formularios sobre fondo oscuro. Parte
 * sin marcar y el link abre en otra pestaña para no perder lo que la persona ya escribió.
 * `texto` lleva "{politica}" donde va el link, para que se pueda editar la frase.
 */
export default function AceptaPolitica({ texto, enlace, marcada, onChange, error, disabled, className = '' }) {
    const { selectEnter, selectExit } = useContext(CursorContext);
    const [antes, despues = ''] = String(texto).split('{politica}');

    return (
        <div className={className}>
            <label onMouseEnter={selectEnter} onMouseLeave={selectExit} className="flex cursor-pointer items-start gap-3 text-sm leading-relaxed text-cream/70">
                <input
                    type="checkbox"
                    name="aceptaPolitica"
                    checked={marcada}
                    onChange={(e) => onChange(e.target.checked)}
                    disabled={disabled}
                    required
                    aria-invalid={Boolean(error)}
                    className="peer sr-only"
                />
                <span aria-hidden="true" className="mt-px flex h-5 w-5 flex-none items-center justify-center rounded-md text-ink ring-1 ring-inset ring-cream/40 transition-colors duration-300 peer-checked:bg-cream peer-checked:ring-cream peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-cream [&>svg]:opacity-0 peer-checked:[&>svg]:opacity-100">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="h-3.5 w-3.5">
                        <path d="M5 13l4 4L19 7" />
                    </svg>
                </span>
                <span>
                    {antes}
                    <Link to="/politica-de-privacidad" target="_blank" rel="noopener" className="text-cream underline decoration-cream/40 underline-offset-4 transition-colors duration-300 hover:decoration-cream">
                        {enlace}
                    </Link>
                    {despues}
                </span>
            </label>
            {error && <p role="alert" className="mt-2 text-[13px] text-red-300">{error}</p>}
        </div>
    );
}
